import { render } from "./FATribalAreas.vue?vue&type=template&id=8b858842&scoped=true"
const script = {}

import "./FATribalAreas.vue?vue&type=style&index=0&id=8b858842&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b858842"]])

export default __exports__